import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./login-store";
import categoryReducer from "./kategorija-store";
import postReducer from "./objave-store";
import documentReducer from "./dokument-store";

import uiSlice from "./ui-slice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const store = configureStore({
  reducer: {
    login: loginReducer,
    ui: uiSlice.reducer,
    category: categoryReducer,
    post: postReducer,
    document: documentReducer,
  },
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
